import React from 'react';
import {
  Box,
  Container,
  Header,
  SpaceBetween,
  StatusIndicator,
  ProgressBar
} from '@cloudscape-design/components';

const DomainTypeCard = ({
  title,
  count,
  description,
  selected,
  onClick,
  status,
  confidence
}) => {
  return (
    <div 
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <Container
        header={
          <Header variant="h3">
            {title}
          </Header>
        }
        style={{
          backgroundColor: selected ? '#f2f3f3' : 'transparent',
          borderColor: selected ? '#0972d3' : undefined,
          borderWidth: selected ? '2px' : '1px'
        }}
      >
        <SpaceBetween size="m">
          <Box textAlign="center">
            <Box variant="h1" color="text-body-secondary">
              {count}
            </Box>
            <Box variant="small" color="text-body-secondary">
              Identified Domains
            </Box>
          </Box>
          <SpaceBetween size="xs">
            <StatusIndicator type={
              status === 'complete' ? 'success' :
              status === 'in-progress' ? 'in-progress' :
              'pending'
            }>
              {status === 'complete' ? 'Analysis complete' :
               status === 'in-progress' ? 'Analyzing' :
               'Pending'}
            </StatusIndicator>
            <Box variant="small">
              Confidence Score: {confidence}%
            </Box>
            <ProgressBar
              value={confidence}
              label="Confidence"
              variant="key-value"
            />
          </SpaceBetween>
          <Box variant="small" color="text-body-secondary">
            {description}
          </Box>
        </SpaceBetween>
      </Container>
    </div>
  );
};

export default DomainTypeCard;
